var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgParedesFeed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 156,
    viewBox: "0 0 172 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 172,
    height: 156
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0H174V156H2V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.005 0H103.765L121.597 46.0516L169.86 25.8392L115.005 0Z",
    fill: "#079D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.597 46.0517L161.798 149.786L169.876 144.913V25.855L169.86 25.8393L121.597 46.0517Z",
    fill: "#006B3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.765 0H2.89209V119.75H103.765V0Z",
    fill: "#D7D8D6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M103.765 0H2.89209V119.75H103.765V0Z",
    fill: "url(#paint0_linear)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.765 0L161.798 29.0769V149.786L103.765 119.75V0Z",
    fill: "#00D38D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.77,
    d: "M103.765 0L161.798 29.0769V149.786L103.765 119.75V0Z",
    fill: "url(#paint1_linear)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5844 72.1737V79.608H75.6422L66.4101 72.1737H31.5844Z",
    fill: "#727D79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8474 37.03H66.4098V72.1738L75.6419 79.608H75.8474V37.03Z",
    fill: "#ACACAC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4101 37.03H31.5844V72.1738H66.4101V37.03Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.031 46.9005V79.7967L147.744 92.1976V59.3171L124.031 46.9005Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.032 46.9005L116.554 43.0026V82.3115L124.032 79.5924V46.9005Z",
    fill: "#079D56"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M124.032 79.7966V79.5923L116.554 82.3114V82.3271L147.744 98.6416V92.1976L124.032 79.7966Z",
    fill: "#006B3F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3182 119.546H103.386L161.418 149.581",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.89209,
    y1: 59.8671,
    x2: 103.765,
    y2: 59.8671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 103.765,
    y1: 74.8928,
    x2: 161.798,
    y2: 74.8928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 161.418,
    y1: 134.571,
    x2: 11.3182,
    y2: 134.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgParedesFeed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paredesFeed.1f2a89526fd141a0fcb306cc87287414.svg";